import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import microsoftReducer from "./microsoft/microsoftSlice";
import alertReducer from "./alerts/alertSlice";
// import userStatusReducer from "./auth/authSlice";
// import userProfileReducer from "./userProfile/userProfileSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    microsoft: microsoftReducer,
    alerts: alertReducer,
    // userStatus: userStatusReducer,
    // userProfile: userProfileReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
